export const copyRight = '© Ellen MacArthur Foundation';

export const description =
  'A Fundação Ellen MacArthur trabalha para acelerar a transição para uma economia circular. Desenvolvemos e promovemos o conceito de economia circular e colaboramos com empresas, universidades, formuladores de políticas públicas e instituições para mobilizar soluções sistêmicas em escala global.';

export const registrationNumbers = [
  'Registro de Caridade (Inglaterra e País de Gales): 1130306',
  'Registro OSCR (Escócia): SC043120',
  'Número da Empresa: 6897785',
  'Fundação Ellen MacArthur ANBI RSIN (Países Baixos): 8257 45 925',
];

export const primaryLinks = [
  {
    title: 'Sobre nós',
    url: `/pt/sobre-nos/o-que-fazemos`,
  },
  {
    title: 'Nossa rede',
    url: `/pt/nossa-rede/visao-geral`,
  },
  {
    title: 'Carreiras',
    url: `/pt/carreiras/visao-geral`,
  },
  {
    title: 'Fale conosco',
    url: `/pt/fale-conosco`,
  },
  {
    title: 'Sala de imprensa',
    url: `/pt/sala-de-imprensa/visao-geral`,
  },
];

export const secondaryLinks = [
  // Optional - currently all links fit in one column
];

export const subContentLinks = [
  {
    title: 'Políticas',
    url: '/policies',
  },
  {
    title: 'Cookies',
    url: '/cookies',
  },
];

export const partners = {
  text: 'O trabalho da Fundação Ellen MacArthur conta com o apoio de ',
  linkText: 'Parceiros e Parceiros Estratégicos.',
  linkUrl: '/pt/nossa-rede/nossa-rede',
};

export const socialLinks = [
  {
    type: 'linkedIn',
    alt: 'Link para a página do LinkedIn da EMF. Abre em uma nova aba.',
    url: 'https://uk.linkedin.com/company/ellen-macarthur-foundation',
  },
  {
    type: 'youTube',
    alt: 'Link para a página do YouTube da EMF. Abre em uma nova aba.',
    url: 'https://www.youtube.com/user/made2bemadeagain',
  },
  {
    type: 'instagram',
    alt: 'Link para a página do Instagram da EMF. Abre em uma nova aba.',
    url: 'https://www.instagram.com/fundacaoellenmacarthur/',
  },
  {
    type: 'medium',
    alt: 'Link para a página do Medium da EMF. Abre em uma nova aba.',
    url: 'https://medium.com/@circulareconomy',
  },
];

export const poweredByContentful = {
  text: 'Powered by Contentful',
  url: 'https://www.contentful.com/',
};
